import React from 'react'
import ContactForm from './MainContact/ContactForm.jsx'
import ContactDetails from './MainContact/ContactDetails.jsx'
import { makeStyles, Grid, Typography, Paper } from '@material-ui/core'

const MainContact = () => {
  const useStyles = makeStyles((theme) => ({
    introStyle: {
      display: 'flex',
      textAlign: 'center',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: theme.spacing(4)
    },
    cardStyle: {
      padding: '15px 25px',
      margin: '10px 20px'
    },
    info: {
      color: theme.palette.grey[600]
    }
  }))

  const classes = useStyles()

  return (
    <Grid container component="section" id="contact" justify="space-evenly">
      <Grid className={classes.introStyle} item>
        <Typography variant="h3" paragraph>
          Get in Touch
        </Typography>
        <Typography className={classes.info}>
          We'd love to hear from you. Send us a question or message with the
          form below and we'll be in touch with you as soon as possible.
        </Typography>
      </Grid>
      <Grid className={classes.cardStyle} item component={Paper} xs={12} md={5}>
        <ContactForm />
      </Grid>
      <Grid className={classes.cardStyle} item component={Paper} xs={12} md={5}>
        <ContactDetails />
      </Grid>
    </Grid>
  )
}

export default MainContact
